import { lazy, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Footer from "./components/sections/layout/Footer";
import Navbar from "./components/sections/layout/Navbar";
import Chatbot from "./components/sections/chatbot";
import DeferredSection from "./components/ui/DeferredSection";
import Seo from "./components/Seo";
import BrandHero from "./components/sections/BrandHero";

import "./App.css";

const SITE_URL = "https://vaseegrah.in";
const DEFAULT_IMAGE = `${SITE_URL}/assets/vijaya.png`;

const HOME_SEO = {
  title: "VASEEGRAH VEDA | Luxury Ayurvedic Herbal Beauty & Skincare",
  description:
    "Discover the power of nature with Vaseegrah Veda. Premium handcrafted herbal skincare, hair care, and Ayurvedic beauty rituals for a natural glow.",
  canonical: SITE_URL,
  image: DEFAULT_IMAGE,
};

const CompactBusinessEcosystem = lazy(() => import("./components/sections/CompactBusinessEcosystem"));
const About = lazy(() => import("./components/sections/About"));
const AwardSection = lazy(() => import("./components/sections/Award"));
const GuestInvitations = lazy(() => import("./components/sections/Journal"));
const Philosophy = lazy(() => import("./components/sections/Philosophy"));
const YouTubeShorts = lazy(() => import("./components/sections/YouTubeShorts"));
const Contact = lazy(() => import("./components/sections/Contact"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        window.setTimeout(() => {
          window.scrollTo({
            top: element.offsetTop - 80,
            behavior: "smooth",
          });
        }, 100);
      }

      return;
    }

    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [pathname, hash]);

  return null;
}

function HomePage() {
  return (
    <>
      <main>
        <BrandHero />

        <DeferredSection
          anchorId="ecosystem"
          minHeight={800}
          label="Loading Business Ecosystem"
        >
          <CompactBusinessEcosystem />
        </DeferredSection>

        <About />



        <DeferredSection minHeight={820} label="Loading the award section">
          <AwardSection />
        </DeferredSection>

        <DeferredSection
          anchorId="philosophy"
          minHeight={760}
          label="Loading the philosophy section"
        >
          <Philosophy />
        </DeferredSection>

        <DeferredSection
          anchorId="journal"
          minHeight={1100}
          label="Loading the journal section"
        >
          <GuestInvitations />
        </DeferredSection>

        <DeferredSection minHeight={760} label="Loading the video showcase">
          <YouTubeShorts />
        </DeferredSection>

        <DeferredSection
          anchorId="contact"
          minHeight={760}
          label="Loading the contact section"
        >
          <Contact />
        </DeferredSection>
      </main>
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Seo {...HOME_SEO} />
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;
